import api from './api';

const MonitoringService = {
    /**
     * Obtém estatísticas do sistema (CPU, RAM, Disco)
     */
    getSystemStats: async () => {
        try {
            const response = await api.get('/api/admin/monitor/stats');
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar stats do sistema:', error);
            throw error;
        }
    },

    /**
     * Obtém lista de usuários ativos
     */
    getActiveUsers: async () => {
        try {
            const response = await api.get('/api/admin/monitor/users');
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar usuários ativos:', error);
            throw error;
        }
    },

    /**
     * Obtém logs do sistema
     * @param {number} lines - Quantidade de linhas para buscar
     */
    getLogs: async (lines = 100) => {
        try {
            const response = await api.get(`/api/admin/monitor/logs?lines=${lines}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar logs:', error);
            throw error;
        }
    },

    /**
     * Status da APLICAÇÃO: PM2, bancos, backups, integrações
     */
    getAppStatus: async () => {
        try {
            const response = await api.get('/api/admin/monitor/app');
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar status da aplicação:', error);
            throw error;
        }
    },

    /**
     * Status de NEGÓCIO: vendas PDV/e-commerce, caixas, crediário, syncs
     */
    getBusinessStatus: async () => {
        try {
            const response = await api.get('/api/admin/monitor/business');
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar status de negócio:', error);
            throw error;
        }
    },

    /**
     * Timeline de ALERTAS: erros PM2, backups atrasados, disco, integrações
     */
    getAlertsTimeline: async () => {
        try {
            const response = await api.get('/api/admin/monitor/alerts');
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar timeline de alertas:', error);
            throw error;
        }
    },
};

export default MonitoringService;
